import * as Yup from 'yup';
import EasyFormColumn from '../../../../components/Forms/EasyFormColumn';
import { FieldEditorRender } from '../../../../components/Forms/Renders/FieldEditorRender';
import { TextFieldRender } from '../../../../components/Forms/Renders/TextFieldRender';
import { AgreementResponse } from '../../../../models/Agreement';
import Client from '../../../../models/Client';
import { ApprovalStatus } from '../../../../models/enums/ApprovalStatus';
import { ServiceBase } from '../../../../models/Service';
import { useDeleteAgreementMutation, useGetAgreementsByClientIdQuery, useUpdateAgreementMutation } from '../../../AgreementApi/redux/agreementsApiSlice';

import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ClientBadge } from '../../../../components/Badges/ClientBadge';
import { ServiceBadge } from '../../../../components/Badges/ServiceBadge';
import EasyFormMany from '../../../../components/Forms/EasyFormMany';
import { TextRenderer } from '../../../../components/Forms/Renders/TextRenderer';
import DrawerButton from '../../../../components/DrawerButton';
import { AgreementInfoDialog } from '../../../AgreementApi/agreementInfoDialog/AgreementInfoDialog';
import { PermissionEnum } from '../../../Permission/PermissionEnum';
import { AbilityContext } from '../../../UserApi/logic/Can';

export default function AgreementsTab(props: { client_id: string }) {
    const { t } = useTranslation();

    const SignupSchema = Yup.object().shape({
        clients: Yup.array().required().min(1, t("You have to select at least one client")),
        expiration_date: Yup.date().min(new Date())
    });

    const ability = useContext(AbilityContext)
    const getAgreementRows = (agreements: AgreementResponse[] | undefined) => {
        const rows: Array<FieldEditorRender[]> = []
        agreements?.forEach((agreement) => {
            const newRow: FieldEditorRender[] = [
                new TextRenderer({
                    fieldName: "",
                    nestedfieldName: "service",
                    render: (service) => (<ServiceBadge ressource={service as unknown as ServiceBase} />),
                    displayText: "Service",
                    uniqueId: agreement.uuid
                }),
                new TextRenderer({
                    fieldName: "",
                    nestedfieldName: "client",
                    render: (service) => (<ClientBadge ressource={service as unknown as Client} />),
                    displayText: "Client",
                    uniqueId: agreement.uuid
                }),

                new TextFieldRender({
                    displayText: "Description",
                    fieldName: "",
                    nestedfieldName: "description",
                    type: "text",
                    uniqueId: "no_id"
                })
            ]

            rows.push(newRow)
        })
        return rows;
    }


    return (
        <EasyFormMany
            isAllowedToDelete={(serviceResponse) => ability.can(PermissionEnum.CLIENT_WRITE, serviceResponse)}
            isAllowedToEdit={(serviceResponse) => ability.can(PermissionEnum.CLIENT_WRITE, serviceResponse)}
            isAllowedToCreate={(serviceResponse) => ability.can(PermissionEnum.CLIENT_WRITE, serviceResponse)}
            ressourceOwnerId={props.client_id}
            arrayPath=""
            idToFetch={props.client_id}
            requestData={[ApprovalStatus.APPROVED]}
            getManyByIdAction={useGetAgreementsByClientIdQuery}
            saveMutation={useUpdateAgreementMutation}
            jsxAtButtons={(agreement) => (
                <DrawerButton entityUuid={agreement.uuid}>
                    <AgreementInfoDialog agreement={agreement} />
                </DrawerButton>
            )}
            confirmDeletionText="Are you sure you wish to delete this agreement?"
            deleteMutation={useDeleteAgreementMutation}
            SignupSchema={SignupSchema}
            columns={[
                new EasyFormColumn("Agreements", "", [])
            ]}
            getFieldRows={getAgreementRows}
            newButtonTooltip="Add new service approver"
        />
    )
}